var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"course-tree"},_vm._l((_vm.value),function(node){return _c('CourseTreeNode',{key:node.id,attrs:{"mode":_vm.mode,"node":node}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }